export type {IModalProps} from './Modal';
export {default} from './Modal';
